/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'is-fraud-language',
    templateUrl: './fraud-language.component.html',
    styleUrls: ['./fraud-language.component.scss'],
    standalone: false
})

export class FraudLanguageComponent implements OnInit {
    @Input() lineOfBusiness = 'NA';
    @Input() state = 'NA';
    fontFamily = 'arial';
    fontSize = '14px';
    fraudLanguage: object = {};
    notApplicable = 'NA';
    // eslint-disable-next-line @typescript-eslint/member-ordering
    fraudLanguageMap: any[] = [{
        AL: {
            General: 'Alabama law requires us to include the following statement - Any person who knowingly presents a false or ' +
                'fraudulent claim for payment of a loss or benefit or who knowingly presents false information in an application for insurance ' +
                'is guilty of a crime and may be subject to restitution fines or confinement in prison, or any combination thereof.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        AK: {
            General: 'Alaska law requires us to include the following statement - A person who knowingly and with intent to injure, ' +
                'defraud or deceive an insurance company files a claim containing false, incomplete or misleading information may be prosecuted ' +
                'under state law.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        AZ: {
            General: 'For your protection Arizona law requires the following statement to appear on this form.+Any person who knowingly presents a false or fraudulent claim for payment of a loss is subject to criminal and civil penalties.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        AR: {
            General: 'Arkansas law requires us to include the following statement - Any person who knowingly presents a+false or fraudulent claim for payment of a loss or benefit or knowingly presents false information in an application for+insurance is guilty of a crime and may be subject to fines and confinement in prison.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': 'Arkansas law requires us to include the following statement - Any person or entity who+willfully and knowingly makes any material false statement or representation, or who willfully and knowingly omits or conceals+any material information, or who willfully and knowingly employs any device, scheme or artifice, for the purpose of obtaining any+benefit or payment, or for the purpose of defeating or wrongfully increasing or wrongfully decreasing any claim for benefit+or payment or obtaining or avoiding workers compensation coverage or avoiding payment of the proper insurance +premium or who aids and abets for any of said purposes, under this chapter shall be guilty of a Class D felony.',
            'Commercial Property': this.notApplicable
        },
        CA: {
            General: 'For your protection California Law requires the following to appear on this form:  Any person who knowingly presents+false or fraudulent claim for the payment of a loss is guilty of a crime and may be subject to fines and confinement in state+prison.',
            'General Liability': this.notApplicable,
            'Commercial Auto': 'For your protection California Law requires the following to appear on this form: Any person who knowingly+presents false or fraudulent claim for the payment of a loss is guilty of a crime and may be subject to fines and confinement+in state prison. Warning: This claim form must be signed by the insured. False representations made on this claim form+subject the insured to a penalty of perjury.',
            'Workers Compensation': 'California law requires us to include the following statement - Any person who makes or causes to be made+any knowingly false or fraudulent material statement or material representation for the purpose of obtaining or denying workers+compensation benefits or payments is guilty of a felony.',
            'Commercial Property': this.notApplicable
        },
        CO: {
            General: 'Colorado law requires us to include the following statement - It is unlawful to knowingly provide false, incomplete or+misleading facts or information to an insurance company for the purpose of defrauding or attempting to defraud the company.+Penalties may include imprisonment, fines, denial of insurance and civil damages.  Any insurance company or agent of an insurance+company who knowingly provides false, incomplete or misleading facts or information to a policyholder or claimant for the purpose+of defrauding or attempting to defraud the policyholder or claiming with regard to a settlement or award payable for insurance+proceeds shall be reported to the Colorado Division of Insurance within the Department of Regulatory Agencies.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        CT: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        DE: {
            General: 'Delaware law requires us to include the following statement - Any person who knowingly, and with intent to injure,+defraud or deceive any insurer, files a statement of claim containing any false, incomplete or misleading information is+guilty of a felony.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        DC: {
            General: 'WARNING:  It is a crime to provide false or misleading information to an insurer for the purpose of defrauding+the insurer or any other person.  Penalties include imprisonment and/or fines.  In addition, an insurer may deny insurance+benefits if false information materially related to a claim was provided by the applicant.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        FL: {
            General: 'Florida law requires us to include the following statement - Any person who knowingly and with intent to injure,+defraud or deceive any insurance company files a statement of claim containing any false, incomplete or misleading information+is guilty of a felony of the third degree.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': 'Florida law requires us to include the following statement - Any person who, knowingly and with intent to+injure, defraud or deceive any employer or employee, insurance company, or self-insured program, files a statement of claim+containing any false or misleading information commits insurance fraud, punishable as provided in s. 817.234',
            'Commercial Property': this.notApplicable
        },
        GA: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        HI: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        ID: {
            General: 'Idaho law requires us to include the following statement - Any person who knowingly, and with intent to defraud or+deceive any insurance company, files a statement containing any false, incomplete or misleading information is guilty of a felony.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        IL: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        IN: {
            General: 'Indiana law requires us to include the following statement - A person who knowingly and with intent to defraud an+insurer files a statement of claim containing any false, incomplete, or misleading information commits a felony.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        IA: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        KS: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        KY: {
            General: 'Kentucky law requires us to include the following statement - Any person who knowingly and with intent to defraud any+insurance company or other person files a statement of claim containing any materially false information or conceals, for the+purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        LA: {
            General: 'Louisiana law requires us to include the following statement - Any person who knowingly presents a false or fraudulent+claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is guilty of a crime+and may be subject to fines and confinement in prison.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': 'Louisiana law requires us to include the following statement - Any person who knowingly presents a false or+fraudulent claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is+guilty of a crime and may be subject to fines and confinement in prison.  Failure to answer truthfully may result in+forfeiture of workers compensation benefits.',
            'Commercial Property': this.notApplicable
        },
        ME: {
            General: 'Maine law requires us to include the following statement - It is a crime to knowingly provide false, incomplete or+misleading information to an insurance company for the purpose of defrauding the company.  Penalties may include imprisonment,+fines or denial of insurance benefits.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        MD: {
            General: 'Maryland law requires us to include the following statement - Any person who knowingly or willfully presents a false or+fraudulent claim for payment of a loss or benefit or who knowingly or willfully presents false information in an application+for insurance is guilty of a crime and may be subject to fines and confinement in prison.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        MA: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        MI: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        MN: {
            General: 'Minnesota law requires us to include the following statement - A person who files a claim with intent to defraud or helps+commit a fraud against an insurer is guilty of a crime.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': 'Minnesota law requires us to include the following statement - Any person who, with intent to defraud,+receives workers’ compensation benefits to which the person is not entitled by knowingly misrepresenting, misstating or failing+to disclose any material fact is guilty of theft and shall be sentenced pursuant to section 609.52, Subdivision 3.',
            'Commercial Property': this.notApplicable
        },
        MS: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        MO: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        MT: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        NE: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        NV: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        NH: {
            General: 'New Hampshire law requires us to include the following statement - Any person who, with a purpose to injure, defraud or+deceive any insurance company, files a statement of claim containing any false, incomplete or misleading information is subject+to prosecution and punishment for insurance fraud, as provided in section 638:20.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        NJ: {
            General: 'New Jersey law requires us to include the following statement - Any person who knowingly files a statement of claim+containing any false or misleading information is subject to criminal and civil penalties.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        NM: {
            General: 'New Mexico law requires us to include the following statement - Any person who knowingly presents a false or fraudulent+claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is guilty of a+crime and may be subject to civil fines and criminal penalties',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        NY: {
            General: 'New York law requires us to include the following statement - Any person who knowingly and with intent to defraud any+insurance company or other person files an application for insurance or statement of claim containing any materially false+information, or conceals for the purpose of misleading, information concerning any fact material thereto, commits a fraudulent+insurance act, which is a crime and shall be subject to a civil penalty not to exceed five thousand dollars and the stated+value of the claim for each such violation.',
            'General Liability': this.notApplicable,
            'Commercial Auto': 'New York law requires us to include the following statement - Any person who knowingly makes or knowingly+assists, abets, solicits or conspires with another to make a false report of theft, destruction, damage or conversion of any+motor vehicle to a law enforcement agency, the department of motor vehicles or an insurance company, commits a fraudulent+insurance act, which is a crime, and shall also be subject to a civil penalty not to exceed five thousand dollars and the value+of the subject motor vehicle or stated claim for each violation.',
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        NC: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        ND: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        OH: {
            General: 'Ohio law requires us to include the following statement - Any person who with intent to defraud or knowing that he is+facilitating a fraud against an insurer, submits an application or files a claim containing a false or deceptive statement is+guilty of insurance fraud.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        OK: {
            General: 'WARNING:  Any person who knowingly, and with intent to injure, defraud or deceive any insurer, makes any claim for+the proceeds of an insurance policy containing any false, incomplete or misleading information is guilty of a felony.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        OR: {
            General: 'Oregon law requires us to include the following statement - Any person who knowingly and willfully presents a false or+fraudulent claim for payment of a loss or benefit or who knowingly and willfully presents false information in an application+for insurance is guilty of a crime and may be subject to fines and confinement in prison.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        PA: {
            General: 'Pennsylvania law requires us to include the following statement - Any person who knowingly and with intent to defraud any+insurance company or other person files an application for insurance or statement of claim containing any materially false+information or conceals for the purpose of misleading, information concerning any fact material thereto commits a fraudulent+insurance act, which is a crime and subjects such person to criminal and civil penalties.',
            'General Liability': this.notApplicable,
            'Commercial Auto': 'Pennsylvania law requires us to include the following statement - Any person who knowingly and with intent to+injure or defraud any insurer files an application or claim containing any false, incomplete or misleading information shall, upon+conviction, be subject to imprisonment for up to seven years and the payment of a fine up to $15,000.',
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        RI: {
            General: 'Rhode Island law requires us to include the following statement - Any person who knowingly presents a false or fraudulent+claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is guilty of+a crime and may be subject to fines and confinement in prison.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        SC: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        SD: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        TN: {
            General: 'Tennessee law requires us to include the following statement - It is a crime to knowingly provide false, incomplete or+misleading information to an insurance company for the purpose of defrauding the company.  Penalties include imprisonment,+fines and denial of insurance benefits.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': 'Tennessee law requires us to include the following statement - It is a crime to knowingly provide false,+incomplete or misleading information to any party to a worker\'s compensation transaction for the purpose of committing fraud.+Penalties include imprisonment, fines and denial of insurance benefits.',
            'Commercial Property': this.notApplicable
        },
        TX: {
            General: 'Texas law requires us to include the following statement - Any person who knowingly presents a false or fraudulent+claim for the payment of a loss is guilty of a crime and may be subject to fines and confinement in state prison.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        UT: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': 'Utah law requires us to include the following statement - Any person who knowingly presents false or+fraudulent underwriting information, files or causes to be filed a false or fraudulent claim for disability compensation or+medical benefits, or submits a false or fraudulent report or billing for health care fees or other professional services is+guilty of a crime and may be subject to fines and confinement in state prison.',
            'Commercial Property': this.notApplicable
        },
        VT: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        VA: {
            General: 'Virginia law requires us to include the following statement - It is a crime to knowingly provide false, incomplete or+misleading information to an insurance company for the purpose of defrauding the company.  Penalties include imprisonment, fines+and denial of insurance benefits.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        WA: {
            General: 'Washington law requires us to include the following statement - It is a crime to knowingly provide false, incomplete or+misleading information to an insurance company for the purpose of defrauding the company.  Penalties include imprisonment, fines+and denial of insurance benefits.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        WV: {
            General: 'West Virginia law requires us to include the following statement - Any person who knowingly presents a false or+fraudulent claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is+guilty of a crime and may be subject to fines and confinement in prison.',
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        WI: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        },
        WY: {
            General: this.notApplicable,
            'General Liability': this.notApplicable,
            'Commercial Auto': this.notApplicable,
            'Workers Compensation': this.notApplicable,
            'Commercial Property': this.notApplicable
        }
    }];
    general = 'General';
    language: string;
    // defaulting the all of the state font styles to be based on the state with the most stringent requirments

    showFraudLanguage = true;

    ngOnInit(): void {
        this.fraudLanguage = this.fraudLanguageMap[0][this.state];
        if (this.fraudLanguage) {
            this.language = this.fraudLanguage[this.lineOfBusiness];
            if (this.language === this.notApplicable) {
                this.language = this.fraudLanguage[this.general];
                // checking to see if fraud language exists for given state/policy type
                if (this.language === this.notApplicable) {
                    this.showFraudLanguage = false;
                }
            }
        }
        if (!this.language) {
            this.showFraudLanguage = false;
        }
    }
    constructor() { }
}
